import api from "@/lib/api";

const CHUNK = 2 * 1024 * 1024;

export async function uploadBlobChunked(blob, onProgress) {
  const { data } = await api.post("/uploads/init");
  const total = Math.max(1, Math.ceil(blob.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const part = blob.slice(i * CHUNK, (i + 1) * CHUNK);
    await api.put(`/uploads/${data.upload_id}/chunk/${i}`, part, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(i + 1, total);
  }
  return data.upload_id;
}
